function Redirect() {
  window.location.replace(process.env.REACT_APP_REDIRECT_URI);
  return null;
}

export default Redirect;
